import { webApi } from "../../../../core/http/httpThunks";
import { DividendData } from "../types";

export const getTradeApi = (userId: string, divid: string) => {
 // console.log("Poziva se getTradeApi sa:", { userId, divid });

  return webApi<DividendData>({
    method: "GET",
    url: "reporting/getdividend",
    params: {
      userId,
      divid,
    },
  });
};

export default getTradeApi;
